import { render, staticRenderFns } from "./NumberProductInOrderTemplate.vue?vue&type=template&id=d8262760&scoped=true&"
import script from "./NumberProductInOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./NumberProductInOrderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8262760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8262760')) {
      api.createRecord('d8262760', component.options)
    } else {
      api.reload('d8262760', component.options)
    }
    module.hot.accept("./NumberProductInOrderTemplate.vue?vue&type=template&id=d8262760&scoped=true&", function () {
      api.rerender('d8262760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/NumberProductInOrderTemplate.vue"
export default component.exports